<template>
  <div v-if="error || deleteError" class="fill-height">
    <PageNotFound v-if="error === 'Not Found'" />
    <GenericError v-else />
  </div>
  <div v-else>
    <div v-if="isLoading || deleteLoading || !retrieved" class="content-spinner">
      <v-progress-circular indeterminate size="75" color="primary"></v-progress-circular>
    </div>
    <template v-else>
      <UserForm
        v-if="item"
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :handle-delete="del"
        :values="item"
        :errors="violations"
        :initial-values="retrieved"
      />
    </template>
  </div>
</template>

<script>
import GenericError from '@/components/error/GenericError'
import PageNotFound from '@/components/error/PageNotFound'
import { mapActions, mapGetters } from 'vuex'
import UserForm from './Form.vue'

export default {
  components: {
    UserForm,
    GenericError,
    PageNotFound
  },

  data() {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'user/update/isLoading',
      error: 'user/update/error',
      deleteError: 'user/del/error',
      deleteLoading: 'user/del/isLoading',
      created: 'user/create/created',
      deleted: 'user/del/deleted',
      retrieved: 'user/update/retrieved',
      updated: 'user/update/updated',
      violations: 'user/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function(deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'UserList' })
    },
    updated: function(updated) {
      if (!updated) {
        return
      }

      this.$router.push({ name: 'UserList' })
    },
    retrieved: function(retrieved) {
      if (!retrieved) {
        return
      }
    }
  },

  created() {
    this.$emit('navPrev', { name: 'UserList' })
    this.retrieve('/users/' + this.$route.params.id)
  },

  methods: {
    ...mapActions({
      deleteItem: 'user/del/del',
      retrieve: 'user/update/retrieve',
      update: 'user/update/update',
      updateRetrieved: 'user/update/updateRetrieved'
    }),

    del() {
      this.deleteItem(this.retrieved)
    },

    onSendForm() {
      this.update()
    },

    updateField(field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
